import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PpsUtilityService } from "../services/pps-utility.service";
import { EmployeeBase } from "../shared/models/employee-base";
import { ITrainingCourse } from "../shared/models/training-course";
import { IEmployeeTrainingRecord } from "../shared/models/employee-training-record";
import { NgForm } from "@angular/forms";

@Component({
  selector: "pps-employee-training-record-form",
  templateUrl: "./employee-training-record-form.component.html"
})
export class EmployeeTrainingRecordFormComponent{
  employees: EmployeeBase[] = [];
  courses: ITrainingCourse[] = [];
  employeeTrainingRecord: IEmployeeTrainingRecord = null;
  selectedEmployee: EmployeeBase = null;
  isUpdate: boolean = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService) {}

  ngOnInit(): void {
    this.employees = this.dlgConfig.data.employees;
    this.courses = this.dlgConfig.data.courses;
    this.employeeTrainingRecord = this.dlgConfig.data.employeeTrainingRecord;
  }

  cancel(){
    this.dialogRef.close();
  }

  save(form: NgForm){
    console.log(form);
    if (form.invalid){
      return false;
    }

    console.log(this.employeeTrainingRecord);

    this.dialogRef.close(this.employeeTrainingRecord);
  }

  getEmployeeName(employee: EmployeeBase): string{
    return this._util.getEmployeeName(employee);
  }
}